/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Address_DistrictInputs */

const en_clients_field_address_district = /** @type {(inputs: Clients_Field_Address_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`District`)
};

const pt_br2_clients_field_address_district = /** @type {(inputs: Clients_Field_Address_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bairro`)
};

/**
* | output |
* | --- |
* | "District" |
*
* @param {Clients_Field_Address_DistrictInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_address_district = /** @type {((inputs?: Clients_Field_Address_DistrictInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Address_DistrictInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_address_district(inputs)
	return pt_br2_clients_field_address_district(inputs)
});